import { PropsWithChildren } from "react";

import PlusIcon from "@assets/icons/plus.svg";

import { ITagResponse } from "@interfaces/responses.interface";
import { cn } from "@utils/tailwind.util";

interface Props {
  item: ITagResponse;
  onSubmit?: (tag: ITagResponse) => void;
  isMember?: boolean;
  isDisabled?: boolean;
}

export function SuggestedItemWrapper({
  item,
  onSubmit,
  isMember,
  isDisabled,
  children,
}: PropsWithChildren<Props>) {
  const handleSubmit = () => {
    if (!isDisabled) {
      onSubmit?.(item);
    }
  };

  return (
    <div className="group relative min-w-0 max-w-full">
      <div
        className={cn(
          "inline-flex h-7 w-full cursor-pointer items-center gap-2 rounded-md bg-background-tag p-1 pr-2 align-middle leading-none no-underline outline-none ring-1 ring-inset ring-stroke-primary text-content-primary transition-colors group-hover:bg-gray-200",
          "dark:bg-gray-750 dark:ring-gray-700 dark:group-hover:bg-gray-800",
          {
            "bg-background-tagMemberDefault dark:bg-background-tagMemberDefault": isMember,
            "cursor-not-allowed": isDisabled,
          }
        )}
        onClick={handleSubmit}
      >
        <PlusIcon className="flex-shrink-0 dark:text-white" />

        {children}
      </div>
    </div>
  );
}
